import React from 'react';
import { Tooltip } from '@c2fo/liquidity';

interface CopyableIdProps {
  value: string;
  className?: string;
}

export const CopyableId: React.FC<CopyableIdProps> = ({ value, className = '' }) => {
  return (
    <Tooltip.Provider>
      <Tooltip>
        <Tooltip.Trigger asChild>
          <button
            type="button"
            className={`block w-full text-left truncate hover:text-primary-600 cursor-pointer ${className}`}
            onClick={() => navigator.clipboard.writeText(value)}
            title="Click to copy"
          >
            {value}
          </button>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content variant="dark" arrow>
            {value}
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip>
    </Tooltip.Provider>
  );
};
